import type { ReactElement } from 'react';
import { connect } from 'react-redux';
import type { DispatchType } from '../../../../store/utils/dispatchType';
import { logout } from '../../../../store/authentication/actions';
import { translateKey } from '../../../../translate';
import { IconColor } from '../../atoms/icon/Icon';
import { Component } from '../../Component';
import { Container } from '../../molecules/container/Container';
import { GoBackButton } from '../../molecules/goBackButton/GoBackButton';
import { IconLink } from '../../molecules/iconLink/IconLink';
import { Logo } from '../../molecules/logo/Logo';

interface IHeaderProps {
    backButtonText?: string;
    backUrl?: string;
    customBackButton?: ReactElement;
    disableLogoLink?: boolean;
    dispatch: DispatchType;
    hasBackbutton?: boolean;
    hasLogoutButton?: boolean;
}

class HeaderWrapper extends Component<IHeaderProps, unknown> {
    public constructor(props: IHeaderProps) {
        super(props);
    }

    public render() {
        const backButton = this.props.customBackButton || (
            <GoBackButton backUrl={this.props.backUrl}>
                {this.props.backButtonText || translateKey('common.goBack')}
            </GoBackButton>
        );

        return (
            <div className="header">
                <Container isFluidOnMobile>
                    {this.props.hasBackbutton && backButton}
                    <Logo disableLink={this.props.disableLogoLink} />
                    {this.props.hasLogoutButton && (
                        <IconLink
                            className="ml-auto"
                            color={IconColor.muted}
                            icon="logout"
                            linkColor="muted"
                            noTextDecoration
                            onClick={() => this.onLogout()}
                            position="right"
                            to="#"
                        >
                            Uitloggen
                        </IconLink>
                    )}
                </Container>
            </div>
        );
    }

    private onLogout() {
        this.props.dispatch(logout());
    }
}

export const Header = connect(null)(HeaderWrapper);
